module.exports = __webpack_public_path__ + "img/interviews.f99cf3c1.svg";